"use client";

import React from "react";
import { Button } from "@os/components/ui/button";
import { ChevronUp, ChevronDown } from "lucide-react";

type MapleWordRibbonToggleProps = {
  collapsed: boolean;
  onToggle: () => void;
};

const MapleWordRibbonToggle: React.FC<MapleWordRibbonToggleProps> = ({ collapsed, onToggle }) => {
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="absolute top-16 right-3 md:right-4 z-30 rounded-full shadow-sm"
      onMouseDown={(e) => {
        e.preventDefault();
        onToggle();
      }}
      title={collapsed ? "Show ribbon" : "Hide ribbon"}
      aria-label={collapsed ? "Show ribbon" : "Hide ribbon"}
    >
      {collapsed ? <ChevronDown className="w-4 h-4" /> : <ChevronUp className="w-4 h-4" />}
    </Button>
  );
};

export default MapleWordRibbonToggle;